
<h3 class="related" *ngIf="(data$ | async).length>0">
  Productos relacionados
</h3>


<div style="margin: 20px 20px 20px 20px" class="row">

  <ng-container *ngIf="isLoading$ | async ; else template">
    <div *ngFor="let product of [1,2,3,4,5,6]" style="display:flex;" class="col-lg-2 col-6">
      <div class="tab-item">
        <div class="tab-img">

          <ngx-skeleton-loader animation="progress" animation="true" appearance="line" [theme]="theme">
          </ngx-skeleton-loader>

        </div>
        <div style="min-height: 80px;" class="tab-heading">

          <ngx-skeleton-loader animation="progress" appearance="line"
            [theme]="{ margin: '-15px 0 0 10px', width: '160px', height: '28px',background: '#f1f1f1'}">
          </ngx-skeleton-loader>

          <ngx-skeleton-loader animation="progress" appearance="line"
            [theme]="{ margin: '0 0 0 10px', width: '110px', height: '20px',background: '#f1f1f1'}">
          </ngx-skeleton-loader>

        </div>

      </div>
    </div>
  </ng-container>

  <ng-template #template>
    <div *ngFor="let product of data$ | async; let index = index;" style="display:flex;" class="col-lg-2 col-6 items">
      <div id="{{product.code}}" class="tab-item">


        <div class="tab-img">

          <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="theme">
          </ngx-skeleton-loader>

          <img *ngIf="product.provider==0" routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}'
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

          <img *ngIf="product.provider==1" routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}'
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

          <img *ngIf="product.provider==2" (click)="getDetails(product.code,product.provider)"
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

            <img *ngIf="product.provider==3" (click)="getDetails(product.code,product.provider)"
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

            <img *ngIf="product.provider==4" (click)="getDetails(product.code,product.provider)"
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

            <img *ngIf="product.provider==5" (click)="getDetails(product.code,product.provider)"
            [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
            src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="product.loaded=true">

        </div>

        <div style="min-height: 80px;" class="tab-heading">
          <h3 *ngIf="product.provider==0">
            <a routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}'>
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </h3>

          <h3 *ngIf="product.provider==1">
            <a routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}'>
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </h3>

          <p *ngIf="product.provider==2">
            <a  href="javascript: void(0)" (click)="getDetails(product.code,product.provider)">
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </p>

          <p *ngIf="product.provider==3">
            <a  href="javascript: void(0)" (click)="getDetails(product.code,product.provider)">
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </p>

          <p *ngIf="product.provider==4">
            <a  href="javascript: void(0)" (click)="getDetails(product.code,product.provider)">
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </p>

          <p *ngIf="product.provider==5">
            <a  href="javascript: void(0)" (click)="getDetails(product.code,product.provider)">
              {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
            </a>
          </p>

          <div class="img-content d-flex justify-content-between">
            <ul title="{{product.rating}}" [innerHtml]="product.rating | start" class="rating list-unstyled list-inline fav">
            </ul>
          </div>
        </div>

        <div class="img-content d-flex justify-content-between">
          <div style="margin-top:10px">
            <ul class="list-unstyled list-inline price">
              <li class="list-inline-item">{{product.priceToShow}}</li>
              <li style="text-decoration: line-through;" class="list-inline-item">{{product.oldPriceToShow}}</li>
            </ul>
          </div>

        </div>
        <div *ngIf="product.provider==1" class="amazon-item">
          <img src="assets/amazon-logo.svg" alt="Amazon">
        </div>
        <div *ngIf="product.provider==2" class="amazon-item">
          <img src="assets/shein-logo.svg" alt="Shein">
        </div>
        <div *ngIf="product.provider==3" class="amazon-item">
          <img src="assets/walmart-icon.svg" alt="Walmart">
        </div>
        <div *ngIf="product.provider==4" class="amazon-item">
          <img src="assets/homedepot-logo.svg" alt="HomeDepot">
        </div>
        <div *ngIf="product.provider==5" class="amazon-item">
          <img src="assets/bestbuy-icon.svg" alt="BestBuy">
        </div>
      </div>
    </div>
  </ng-template>

</div>

